import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import { CONTEXT_API_RECUPERER_FICHIER_TELECHARGEMENT } from '../../constants/apiUrls.constants';

const fichier = combineReducers({
    fichierTelechargement: APIReducer.bind(null, CONTEXT_API_RECUPERER_FICHIER_TELECHARGEMENT),
});

export default fichier;
